import { render, staticRenderFns } from "./ManageNotification.vue?vue&type=template&id=6adae6ce&scoped=true&"
import script from "./ManageNotification.vue?vue&type=script&lang=js&"
export * from "./ManageNotification.vue?vue&type=script&lang=js&"
import style0 from "./ManageNotification.vue?vue&type=style&index=0&id=6adae6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adae6ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VRow})
